import { BrowserModule } from "@angular/platform-browser";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { KendoModule } from "src/app/modules/kendo.module";
import { NgModule } from "@angular/core";
import { OrdersComponent } from "../components/orders/orders.component";
import { RouterModule } from "@angular/router";

@NgModule({ declarations: [
        OrdersComponent
    ],
    exports: [
        OrdersComponent
    ], imports: [BrowserModule,
        RouterModule,
        KendoModule], providers: [
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AllSARModule { }
